"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* ========================================================================
    Application main script
 ========================================================================== */
const confirm_delete_1 = require("~modules/confirm-delete");
const no_copy_paste_1 = require("~modules/no-copy-paste");
const enable_apply_next_button_1 = require("~modules/enable-apply-next-button");
const enable_fullname_remarks_1 = require("~modules/enable-fullname-remarks");
const school_input_visibility_1 = require("~modules/school-input-visibility");
const auto_fill_forms_1 = require("~modules/auto-fill-forms");
const school_search_1 = require("~modules/school-search");
const questionnaire_1 = require("~modules/questionnaire");
const file_registration_1 = require("~modules/file-registration");
const datepicker_1 = require("~modules/datepicker");
const droparea_visibility_1 = require("~modules/droparea-visibility");
const work_file_registration_1 = require("~modules/additional-application/work-file-registration");
const applicant_list_registration_1 = require("~modules/additional-application/applicant-list-registration");
// Confirm delete.
window.addEventListener("DOMContentLoaded", confirm_delete_1.confirmDlete);
window.addEventListener("DOMContentLoaded", confirm_delete_1.confirmDleteLink);
// No copy and paste.
window.addEventListener("DOMContentLoaded", no_copy_paste_1.noCopyAndPaste);
// 注意事項の同意がすべてチェックされていればボタンを有効化する
window.addEventListener("DOMContentLoaded", enable_apply_next_button_1.enableApplyNextButton);
// 氏名表記に関する備考のチェックによって入力フォームを有効／無効化する
window.addEventListener("DOMContentLoaded", enable_fullname_remarks_1.enableFullnameRemarks);
// FAX番号のチェックによって入力フォームを有効／無効化する
window.addEventListener("DOMContentLoaded", enable_fullname_remarks_1.enableFaxNumber);
// 学校情報の入力種別によって入力フォームを有効／無効化する
// ※Remodal の閉じるボタンに影響しないように load イベントでリスナーを追加
window.addEventListener("load", school_input_visibility_1.schoolInputVisibility);
// 海外応募のチェックによって自動入力をする
window.addEventListener("DOMContentLoaded", auto_fill_forms_1.checkedOverseaAutoFill);
// 郵便番号に「0000000」を指定で自動入力する
window.addEventListener("DOMContentLoaded", auto_fill_forms_1.postCodeOverseaAutoFill);
// 学校情報を検索して自動入力する
window.addEventListener("DOMContentLoaded", school_search_1.schoolSearch);
// アンケートの回答のチェックによってサブ項目を有効／無効化する
window.addEventListener("DOMContentLoaded", questionnaire_1.questionnaireItemEnabled);
// ファイルを登録／削除する
window.addEventListener("DOMContentLoaded", file_registration_1.enableUploadButtonNotesCheckboxState);
window.addEventListener("DOMContentLoaded", file_registration_1.getRegistrationFile);
window.addEventListener("DOMContentLoaded", file_registration_1.uploadRegistrationFileButton);
window.addEventListener("DOMContentLoaded", file_registration_1.preUploadRegistrationFileButton);
window.addEventListener("DOMContentLoaded", file_registration_1.uploadRegistrationFileDnD);
window.addEventListener("DOMContentLoaded", file_registration_1.preUploadRegistrationFileDnD);
window.addEventListener("DOMContentLoaded", file_registration_1.deleteRegistrationFile);
// 追加応募ファイルを登録／削除する
window.addEventListener("DOMContentLoaded", work_file_registration_1.WorkFileRegistration);
window.addEventListener("DOMContentLoaded", applicant_list_registration_1.ApplicantListRegistration);
// 一括ダウンロードの Date picker を設定する
window.addEventListener("DOMContentLoaded", datepicker_1.batchDownloadDatepicker);
// ファイルアップロードのドロップエリアをモバイルデバイスの時のみ非表示にする
window.addEventListener("DOMContentLoaded", droparea_visibility_1.dropareaVisibility);
